import { Dictionary, Vehicle } from '@common/types';
import { createSelector } from 'reselect';
import { catalogDictionaryNameSelector } from '@modules/catalog/selectors';
import { getTrailersRefData } from '@modules/catalog/helpers/selectors/get-trailers-ref-data';

export const catalogRoadTrainOptionsSelector = ({ RearCouplingTypeID }: { RearCouplingTypeID: Vehicle['RearCouplingTypeID'] }) =>
  createSelector(catalogDictionaryNameSelector(Dictionary.Vehicle, 'data'), (vehicleData: Array<Vehicle>) => {
    return { refData: getTrailersRefData({ vehicleData, RearCouplingTypeID }) };
  });
